import { gsap } from 'gsap';

let STOPSLIDERS = false;

const ALTHEIM = [
  "url('https://weinhandel-weber.de/assets/standorte-slider/Am01.jpg')",
  "url('https://weinhandel-weber.de/assets/standorte-slider/Am02.jpg')",
  "url('https://weinhandel-weber.de/assets/standorte-slider/Am03.jpg')",
  "url('https://weinhandel-weber.de/assets/standorte-slider/Am04.jpg')",
  "url('https://weinhandel-weber.de/assets/standorte-slider/Am05.jpg')",
  "url('https://weinhandel-weber.de/assets/standorte-slider/Am06.jpg')",
  "url('https://weinhandel-weber.de/assets/standorte-slider/Am07.jpg')",
];

const startSlider = (wrapper, auto = true) => {
  let isAnimating = false;
  let running = auto;
  const slider = wrapper.querySelector('.standorte__img-slider');
  const IMAGES = ALTHEIM;

  window.addEventListener('focus', () => {
    running = auto;
  });

  window.addEventListener('blur', () => {
    running = false;
  });

  wrapper.addEventListener('mouseleave', () => {
    running = auto;
    startInterval();
  });

  wrapper.addEventListener('mouseenter', () => {
    running = false;
  });

  let interval;
  const startInterval = () => {
    if (interval) clearInterval(interval);
    interval = setInterval(() => {
      if (running && !STOPSLIDERS) next(0.75);
    }, 3500);
  };
  startInterval();

  let currentPos = 0;

  const next = (duration = 0.25) => {
    if (isAnimating) return;
    isAnimating = true;
    const currentImages = Array.from(wrapper.querySelectorAll('.standorte__img'));

    const currentImage = currentImages.find((el) => el.dataset.pos === currentPos.toString());

    const newImage = document.createElement('div');
    newImage.classList.add('standorte__img');

    let nextPos = currentPos + 1;
    if (nextPos >= IMAGES.length) nextPos = 0;

    const bgImage = IMAGES[nextPos];
    newImage.style.backgroundImage = bgImage;
    newImage.dataset.pos = nextPos.toString();
    currentPos = nextPos;

    slider.appendChild(newImage);
    gsap.set(newImage, {
      x: '+100%',
    });

    gsap.to(newImage, {
      duration,
      x: '0%',
    });

    gsap.to(currentImage, {
      duration,
      x: '-100%',
      onComplete: () => {
        slider.removeChild(currentImage);
        isAnimating = false;
      },
    });
  };

  const prev = (duration = 0.25) => {
    if (isAnimating) return;
    isAnimating = true;
    const currentImages = Array.from(wrapper.querySelectorAll('.standorte__img'));

    const currentImage = currentImages.find((el) => el.dataset.pos === currentPos.toString());

    const newImage = document.createElement('div');
    newImage.classList.add('standorte__img');

    let nextPos = currentPos - 1;
    if (nextPos < 0) nextPos = IMAGES.length - 1;

    const bgImage = IMAGES[nextPos];
    newImage.style.backgroundImage = bgImage;
    newImage.dataset.pos = nextPos.toString();
    currentPos = nextPos;

    slider.appendChild(newImage);
    gsap.set(newImage, {
      x: '-100%',
    });

    gsap.to(newImage, {
      duration,
      x: '0%',
    });

    gsap.to(currentImage, {
      duration,
      x: '+100%',
      onComplete: () => {
        slider.removeChild(currentImage);
        isAnimating = false;
      },
    });
  };

  const stop = () => {
    if (!running) return;
    running = false;
  };

  const arrowRight = wrapper.querySelector('.arrow--right');
  const arrowLeft = wrapper.querySelector('.arrow--left');

  arrowRight.addEventListener('click', (e) => {
    stop();
    next();
  });
  arrowLeft.addEventListener('click', (e) => {
    stop();
    prev();
  });
};

const wrappers = Array.from(document.querySelectorAll('.standorte__img-wrapper'));
wrappers.forEach((wrapper) => {
  if (!wrapper.classList.contains('standorte__img-wrapper--overlay')) {
    startSlider(wrapper);

    wrapper.addEventListener('click', (e) => {
      if (!e.target.classList.contains('fas')) openModal(wrapper);
    });
  }
});

const openModal = (wrapper) => {
  const modalBg = document.querySelector('.standorte__modal-bg');

  const id = 'altheim-modal';
  const modal = document.getElementById(id);
  STOPSLIDERS = true;

  modalBg.style.display = 'block';

  gsap.to(modalBg, {
    duration: 0.25,
    opacity: 1,
  });

  modal.style.display = 'block';

  gsap.to(modal, {
    duration: 0.25,
    opacity: 1,
  });

  modal.addEventListener('click', (e) => {
    console.log(e.target);
    if (!e.target.classList.contains('arrow')) closeModal(modal);
  });

  modalBg.addEventListener('click', () => {
    closeModal(modal);
  });

  startSlider(modal, false);
};

const closeModal = (modal) => {
  const modalBg = document.querySelector('.standorte__modal-bg');

  gsap.to(modal, {
    duration: 0.25,
    opacity: 0,
    onComplete: () => {
      modal.style.display = 'none';
    },
  });

  gsap.to(modalBg, {
    duration: 0.25,
    opacity: 0,
    onComplete: () => {
      modalBg.style.display = 'none';
    },
  });

  STOPSLIDERS = false;
};
